/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryCreateSubCategoryResponse } from './CarpCategoryCreateSubCategoryResponse';

export type CarpCategoryCreateSubCategoryResponseApiRespoonse = {
    data?: CarpCategoryCreateSubCategoryResponse;
    status?: CarpCategoryCreateSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryCreateSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

